<template>
  <div class="d-flex align-items-center" style="gap: 6px">
    <span>{{ params.value }}</span>
    <GrWunschIcon :teilnehmers="params.data?.teilnehmers ?? []" />
  </div>
</template>

<script>
import GrWunschIcon from '@/components/common/gr-wunsch-icon.vue';

export default {
  components: { GrWunschIcon },
};
</script>
